import { observer } from "mobx-react";
import * as React from "react";
import { AppHeader } from "../../components/organisms/AppHeader";
import { Breadcrumb } from "../../components/organisms/Breadcrumb";
import { Sidebar } from "../../components/organisms/Sidebar";
import { store } from "../../store";

@observer
class Template extends React.Component<{
    title?: string;
    wbId?: string;
    locked?: boolean;
}> {
    public sidebar = store.sidebar || "";

    public render(): React.ReactElement {
        return (
            <div className={`page_container ${this.sidebar}`}>
                <div className="header">
                    <AppHeader title={this.props.title} wbId={this.props.wbId} locked={this.props.locked} />
                    <Breadcrumb />
                </div>
                <div className="left">
                    <Sidebar />
                </div>
                <div className="right">
                    <div className="main" data-at_id="main_panel">
                        {this.props.children}
                    </div>
                </div>
                <div className="footer"></div>
            </div>
        );
    }
}

export { Template };
